import styled, { css } from "styled-components";
import { BaseButton } from "@diana-ui/button";

export default styled(BaseButton).attrs(props => ({
  disabled: !!props.disabled
}))(
  ({ theme, disabled }) => css`
    border: 1px solid ${theme.colors.black};
    box-sizing: border-box;
    border-radius: 50px;
    color: ${theme.colors.black};
    padding: ${theme.spaceUnit.sm} ${theme.spaceUnit.xl};
    background-color: transparent;

    :hover {
      background-color: ${theme.colors.grey.grey25};
    }

    :active {
      background-color: ${theme.colors.black};
      color: white;
    }

    ${disabled &&
    css`
      border-color: ${theme.colors.grey.grey50};
      color: ${theme.colors.grey.grey50};
      cursor: default;

      :hover {
        backgroundcolor: transparent;
        color: ${theme.colors.grey.grey50};
      }
    `}
  `
);
